import icEyeOpen from 'assets/images/ic-eye-open.svg'
import Badge from 'components/commons/badge'
import Button from 'components/commons/button'
import { formatDateMoment } from 'utils/utils'

export const TABLE_INTERNAL_MOVEMENT_LIST = {
    name: 'Data Internal Movement',
    column: [
        {
            name: 'Name',
            key: 'full_name',
            className: 'font-bold capitalize',
        },
        {
            name: 'NIP',
            key: 'nip',
        },
        {
            name: 'Length of Service',
            key: 'work_duration',
        },
        {
            name: 'Position',
            key: 'job_title',
            className: 'font-bold capitalize',
        },
        {
            name: 'Department',
            key: 'department',
        },
        {
            name: 'Grade',
            key: 'grade',
            sortable: true,
        },
        {
            name: 'Effective Date',
            key: 'effective_date',
            render: ({ value }) => (value ? formatDateMoment(value, 'D MMMM YYYY') : '-'),
        },
        {
            name: 'Change Type',
            key: 'change_type',
            sortable: true,
            className: 'font-bold capitalize',
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center',
            render: ({ item, onClickItem }) => (
                <Button
                    className='w-[80px]'
                    type='outline'
                    icon={icEyeOpen}
                    title='Preview'
                    onClick={() => onClickItem(item)}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY = {
    page: 1,
    limit: 20,
    search: '',
    status: 'active',
}

export const TABLE_INTERNAL_MOVEMENT_IMPORT = [
    {
        name: 'Name',
        key: 'full_name',
        className: 'font-bold capitalize',
    },
    {
        name: 'NIP',
        key: 'nip',
    },
    {
        name: 'Length of Service',
        key: 'work_duration',
    },
    {
        name: 'Position',
        key: 'job_title',
        className: 'font-bold capitalize',
    },
    {
        name: 'Department',
        key: 'department',
    },
    {
        name: 'Grade',
        key: 'grade',
    },
    {
        name: 'Effective Date',
        key: 'effective_date',
        render: ({ value }) => (value ? formatDateMoment(value, 'D MMMM YYYY') : '-'),
    },
    {
        name: 'Change Type',
        key: 'change_type',
        className: 'font-bold capitalize',
    },
    {
        name: 'Status',
        key: 'status',
        width: 250,
        render: () => <Badge title='invalid' type='invalid' />,
    },
]
